module.exports = __webpack_public_path__ + "media/images/caméras de surveillance-6122d4bfc00db9616208cc7cf2d4d3a3.svg";